import React, { useEffect, useRef, useState } from "react";

import right from "../../../assets/images/QYQW/qyqw-next-icon.png";
import left from "../../../assets/images/QYQW/qyqw-last-icon.png";
import right2 from "../../../assets/images/QYQW/rmxz-next-icon.png";
import left2 from "../../../assets/images/QYQW/rmxz-last-icon.png";
import Slider from "react-slick";
import { queryArchivesList } from "../../../service";
import QyqwHeader from "../Component/QyqwHeader";
import TabList from "../Component/TabList";
import bg1 from "../../../assets/images/QYQW/webp/QXStart-MustRead-bg.webp";
import bg2 from "../../../assets/images/QYQW/webp/QHistory-bg.webp";
import bg3 from "../../../assets/images/QYQW/webp/QPYThing-bg.webp";
import bg4 from "../../../assets/images/QYQW/webp/GQMake-bg.webp";
import bg5 from "../../../assets/images/QYQW/webp/QYSearch-bg.webp";
import circle from "../../../assets/images/QYQW/qsml_left_icon.png";
import expand from "../../../assets/images/QYQW/qsml_expand_icon.png";
import fold from "../../../assets/images/QYQW/qsml_fold_icon.png";
import yun from "../../../assets/images/QYQW/yun.png";
import cls from 'classnames'
import { deleteHtmlTag, htmltoStr } from "../../../utils/index";
import { useNav } from "../../../App";
import { flattenChannels } from "../../../utils/platform";
import { useLocation } from "react-router-dom";
import "./index.scss";
import "../index.scss";

const bgImg = {
  "QXStart-MustRead": bg1,
  QHistory: bg2,
  QPYThing: bg3,
  GQMake: bg4,
  QYSearch: bg5,
};

const rmxz_menu4 = [
  {
    style: "仲尼式",
    type: "经典款",
    des: "传统琴式经典之作，造型中正简洁，整体弧度有圆有方，最受古人欢迎。",
    img: "",
  },
  {
    style: "伏羲式",
    type: "复古款",
    des: "琴头圆润，琴体匀称厚重，相传由中华始祖伏羲创造。",
    img: "",
  },
  {
    style: "落霞式",
    type: "浪漫款",
    des: "琴的两侧呈对称的波状曲线，形如晚霞万千变化，给人以无限遐想。因其形体优美，线条柔和，多为女琴家所爱。",
    img: "",
  },
  {
    style: "蕉叶式",
    type: "创意款",
    des: "整体像一片芭蕉叶，琴边作波浪起伏式叶片，琴身清瘦秀美，是明代才出现的新潮设计。",
    img: "",
  },
];
export default function QYQW() {
  const { pathname } = useLocation();
  const channelNo = pathname?.split("/")?.[2];

  const [imgIndex, setImgIndex] = useState(0);

  const { navData2 } = useNav();
  const flattenedChannels = flattenChannels(navData2);

  let channeldata = flattenedChannels?.filter((item) => {
    return item.channelNo === channelNo;
  })?.[0];

  let channeldataP = flattenedChannels?.filter((item) => {
    return item.channelNo === channeldata?.parentChannelNo;
  })?.[0];

  const settings = {
    centerPadding: "25px",
    className: "center",
    centerMode: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <img src={right} className="slick-img" alt=">" />,
    prevArrow: <img src={left} className="slick-img" alt="<" />,
    customPaging: (i) => (
      <div>
        {i + 1}
        <span>/</span>10
      </div>
    ),
    // afterChange: (swiperIndex) => {
    //   setImgIndex(swiperIndex);
    // },
    beforeChange: (swiperIndex) => {
      setImgIndex(swiperIndex + 1);
    },
  };

  const [list, setList] = useState([]);
  const qyqwRef = useRef(null);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (qyqwRef.current) {
      // qyqwRef.current.style.backgroundImage = `url(${bgImg[channelNo]})`;
      qyqwRef.current.style.background = `url(${bgImg[channelNo]}) no-repeat 0 5rem/100% calc(100% - 5rem)`;
      if (channelNo === 'QHistory') {
        qyqwRef.current.style.background = `url(${bgImg[channelNo]}) repeat-y`;
      }
    }

    queryArchivesList({
      pagination: {
        size: 999,
        page: 1,
      },
      resource: channelNo,
    }).then((res) => {
      let newList = res.records;
      if (channelNo === "QHistory") {
        newList = res.records.map((item) => {
          item.expand = false;
          return item;
        });
      }
      if (res.records) setList(newList);
    });
  }, [channelNo]);
  return (
    <div className="qyqw-page" ref={qyqwRef}>
      {channelNo === 'QHistory' && <>
        <i className="yun1"></i>
        <i className="yun2"></i>
      </>}
      <QyqwHeader title={channeldataP?.channelName} />
      {channelNo === "QXStart-MustRead" && <RMXZ data={list} />}
      {channelNo === "QHistory" && <QSML data={list} setList={setList} />}
      {channelNo === "QPYThing" && <QRYS data={list} />}
      {channelNo === "GQMake" && (
        <div className="gq-make">
          <p className="text-step">
            古琴制作的流程大体可以分解为以下10个步骤：
          </p>
          {list.length > 0 && (
            <div className="slider-container">
              <Slider {...settings}>
                {list.map((item, index) => {
                  return (
                    <div className="slider-item" key={item.archivesId}>
                      <div className="title">
                        <h1>{index === 9 ? index + 1 : "0" + (index + 1)}</h1>
                        <h3>{item.title}</h3>
                      </div>
                      <p
                        className="con content"
                        dangerouslySetInnerHTML={{ __html: item.content }}
                      />
                    </div>
                  );
                })}
              </Slider>
              <img
                src={window.ENV_IMG_PREURL + list[imgIndex].imgSrc}
                className="type-img"
                alt="typeimg"
              />
            </div>
          )}
        </div>
      )}
      {channelNo === "QYSearch" && (
        <div className="qy-search">
          <table className="table">
            <thead>
              <tr className="table-header">
                <th className="term-header">术语</th>
                <th className="definition-header">释义</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index) => (
                <tr key={index} className="table-row">
                  <td className="term-cell">【{item.title}】</td>
                  <td className="definition-cell">
                    {deleteHtmlTag(item.content)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <TabList No="QXStart" defaultTab={channelNo} />
    </div>
  );
}

const QSML = ({ data, setList }) => {
  const handleExpandFold = (index) => {
    let newList = [...data];
    newList[index].expand = !newList[index].expand;
    setList(newList);
    // const leftItem = document.getElementById("left-item-" + index);
    // let newCon = deleteHtmlTag(newList[index].content);
    // leftItem.style.height = newList[index].expand
    //   ? (newCon.length / 45) * 7.8 + (newCon.length % 45) * 7.8 * 0.01 + 5.2 + "rem"
    //   : " 19.5rem";
    // console.log(
    //   "kkk",
    //   newCon.length,
    //   (newCon.length / 45) * 7.8 + (newCon.length % 45) * 7.8 * 0.01 + "rem"
    // );
  };

  return (
    <div className="qy-history">
      <div className="qy-history-left">
        {/* {data.map((_, index) => (
          <div className="left-item" id={"left-item-" + index} key={index}>
            <img src={circle} className="circle-img" alt="circleimg" />
          </div>
        ))} */}
      </div>
      <div className="qy-history-right">
        {data.map((item, index) => (
          <div className="right-item">
            <i className="circle"></i>
            <div className="title-box">
              {item.title.split("").map((titleItem) => {
                return <span className="title-item">{titleItem}</span>;
              })}
            </div>
            {item.expand ? (
              <p
                className="content"
                dangerouslySetInnerHTML={{ __html: item.content }}
              />
            ) : (
              <p className="content">
                {htmltoStr(item.content, item.expand ? 9999999999 : 45)}
              </p>
            )}

            <img
              src={item.expand ? fold : expand}
              className="expand-fold-img"
              alt="展开"
              onClick={() => handleExpandFold(index)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const QRYS = ({ data }) => {
  return (
    <div className="qy-people-thing">
      {data.map((item, index) => {
        return (
          <div className={cls("p-t-item", `p-t-item${index + 1}`)}>
            <div className={`title title${index + 1}`}>
              <span className="mainTitle">{item.title}</span>
              <span className="subTitle">{item.subTitle}</span>
              {index !== 3 && index !== 2 && <img src={yun} className="yun" alt="yun" />}
            </div>

            <p
              className={`content content${index + 1}`}
              dangerouslySetInnerHTML={{ __html: item.content }}
            />
          </div>
        );
      })}
    </div>
  );
};

const RMXZ = ({ data }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <img src={right2} className="slick-img" alt=">" />,
    prevArrow: <img src={left2} className="slick-img" alt="<" />,
  };
  return (
    <div className="qy-rmxz">
      {data.map((item, index) => (
        <div className="rmxz-item" key={index}>
          <div className={`title title${index + 1}`}>{item.title}</div>
          <p
            className={`content content${index + 1}`}
            dangerouslySetInnerHTML={{ __html: item.content }}
          />
          {index === 3 && (
            <div className="slider-container content4-slider">
              <Slider {...settings}>
                {rmxz_menu4.map((sliderItem, index) => {
                  return (
                    <div className="slider-item" key={"sliderItem" + index}>
                      <div className="item-top">
                        <img
                          src={require(`../../../assets/images/QYQW/rmxz_menu4_img${index + 1
                            }.png`)}
                          alt=""
                        />
                        <div className="item-top-title">
                          <span className="item-top-title1">
                            {sliderItem.style}
                          </span>
                          <span className="item-top-title2">
                            {sliderItem.type}
                          </span>
                        </div>
                      </div>
                      <div className="item-bottom">{sliderItem.des}</div>
                    </div>
                  );
                })}
              </Slider>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
